<template>
  <div style="padding: 0 20px">
    <!-- <div style="margin:10px 0">
      <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            size="small"
          ></el-date-picker>

      <el-button type="primary" size="small" @click="handleCreate" v-if="$_has('m-add')">+ 创建会议</el-button>
    </div>-->
    <el-form :inline="true" style="margin-top:10px;">
      <el-form-item label="时间:">
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:250px"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          size="small"
          clearable
          @change="getTimes"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="人员：">
        <el-select
          size="small"
          v-model="selectlabel"
          clearable
          @clear="clearSendlabel"
          placeholder="请选择"
          style="width:250px"
        >
          <el-input
              size="mini"
              clearable
              v-if="treeData1.length != 0"
              placeholder="输入关键字进行过滤"
              v-model="filterText"
              style="width: 300px;margin: 0 20px"
            >
          </el-input>
          <br>
          <el-option :label="selectlabel" :value="selectkey" class="optionTree">
            <el-tree
              :data="treeData1"
              :default-expanded-keys="treeExpandData"
              ref="selectlabel"
              node-key="key"
              show-checkbox
              @check="getChecked2"
              :filter-node-method="filterNode"
            >
              <span class="custom-tree-node1" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span v-if="data.mobile">({{data.jobName}})</span>
              </span>
            </el-tree>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="会议类型:">
        <el-select v-model="type" style="width:150px" clearable size="small" placeholder="请选择">
          <el-option
            v-for="item in selectOptions"
            :key="item.type"
            :label="item.value"
            :value="item.type"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" icon="el-icon-search" @click="ajaxLoadTable">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="manyExport" v-if="$_has('m-export')">导出全部</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="small"
          @click="handleCreate"
          v-if="$_has('m-add')"
          icon="el-icon-plus"
        >创建会议</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button
          type="primary"
          size="small"
          @click="pdfDialog = true"
        >导出pdf</el-button>
      </el-form-item> -->
    </el-form>

    <div
      class="div-box"
      element-loading-text
      :style="{ marginTop:!$_has('m-add')?20+'px':0}"
    >
    <!-- <div
      class="div-box"
      v-loading="vloading"
      element-loading-text
      :style="{ marginTop:!$_has('m-add')?20+'px':0}"
    > -->
      <tableBody
        :diyHeight="'calc(100vh - 200px)'"
        :tableNameList="meetingRecords"
        :tableData="tableData"
        :controller="tableController"
      >
        <template slot="projectVO" slot-scope="list">
          <span>{{getVersionName(list.scope.row)}}</span>
        </template>
        <template slot="startTime" slot-scope="list">
          <span>{{list.scope.row.startTime + '至' + list.scope.row.endTime}}</span>
        </template>
        <template slot="endTime" slot-scope="list">
          <span>{{getTime(list.scope.row.startTime,list.scope.row.endTime)}}</span>
        </template>
        <template slot="content" slot-scope="list">
          <el-button @click="checkDetail(list.scope.row)" type="text" size="small">查看</el-button>
        </template>
        <template slot="control" slot-scope="list">
          <el-button
            type="text"
            size="small"
            v-if="$_has('pdf-out')"
            @click="outPdfBtn(list.scope.row)"
          >导出pdf</el-button>
          <span style="color:#409EFF" v-if="$_has('pdf-out')">|</span>
          <el-button
            @click="handleEdit(list.scope.row)"
            type="text"
            size="small"
            v-if="$_has('m-edit')"
          >编辑</el-button>
          <span style="color:#409EFF" v-if="$_has('m-edit') && $_has('m-del')">|</span>
          <el-button
            @click="handleDelete(list.scope.row)"
            type="text"
            size="small"
            v-if="$_has('m-del')"
          >删除</el-button>
        </template>
      </tableBody>
      <pagination
        style="margin-top: 20px"
        :pageSize="pagesize"
        :currentPage="currentPage"
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
      />
    </div>
    <dialog-panel
      :title="'查看会议内容'"
      :dialogController="textDialog"
      :width="'50%'"
      @cancel="textDialog = false"
      @confirm="textDialog = false"
      :showCancel="false"
      :showConfirm="false"
    >
      <p  v-html="textContent">{{textContent}}</p>
      <div style="font-size:14px">附件下载:</div>
      <div style="padding:10px 20px;line-height:1">
        <div v-for="(item,index) in fileContent" :key="index">
          <span>{{index + 1}}、{{item.fileInfoVO.fileName}}</span>
          <el-button type="text" @click="donwload(item.fileInfoVO)" style="padding:0">下载</el-button>
        </div>
      </div>
      <!-- <el-input
        type="textarea"
        readonly
        v-model="textContent"
        class="elInput"
        :autosize="{ minRows: 4, maxRows: 8}"
      ></el-input> -->

      <!-- <div class="textBox">{{textContent}}</div> -->
    </dialog-panel>
    <dialog-panel
      :title="'导出pdf'"
      :dialogController="pdfDialog"
      :width="'600px'"
      @cancel="pdfDialog = false"
      @confirm="pdfDialog = false"
      :showCancel="false"
      :showConfirm="false"
    >

      <img id="topline" style="display:none" src="@/assets/topline.jpg" alt="">
      <img id="toplogo" style="display:none" src="@/assets/pdfTop.jpg" alt="">
      <!-- <img id="pdfline" style="display:none;height:1px;width:739px;" src="@/assets/line.jpg" alt=""> -->
      <img id="bigTitle" style="display:none;" src="@/assets/bigTitle.jpg" alt="">
      <div class="pdf-top" id="export_top">
        <div class="pt-1">
          <img v-if="currentPdf.fileInfoVO" :src="currentPdf.fileInfoVO.path" alt="">
          <div>{{currentPdf.companyName}}</div>
        </div>
        <div class="pt-line1"></div>
        <div class="pt-line2"></div>
      </div>
      <div id="export_content">
        <div class="pdf-box">
          <h3 style="text-align:center;margin-top:0px">会议记录</h3>
          <p v-if="currentPdf.startTime">时间：{{currentPdf.startTime.split(' ')[0] + ' ' + currentPdf.startTime.split(' ')[1] + '-' + currentPdf.endTime.split(' ')[1]}}</p>
          <p>地点：{{currentPdf.place}}</p>
          <p v-if="currentPdf.hostList">主持人：{{currentPdf.hostList.join('、')}}</p>
          <p v-if="currentPdf.attendeeList">参与人员：{{currentPdf.attendeeList.map(v=>v.name).join('、')}}</p>
          <!-- <p v-if="currentPdf.recorderList">记录：{{currentPdf.recorderList.map(v=>v.name).join('、')}}</p> -->
          <p>会议活动名称：{{currentPdf.topic}}</p>
          <p>
            <div class="pdf-line"></div>
          </p>
          <p>会议内容：</p>
          <div v-html="currentPdf.content"></div>
          <p>特此纪要</p>
        </div>
      </div>
      <div style="text-align:center">
        <el-button id="exportToPdf" type="primary" size="small" @click="exportToPdf1">导出当前内容转为PDF</el-button>
      </div>
    </dialog-panel>
  </div>
</template>
<script>
import router from "../../router";
import * as api from './api'
import { ListMixin } from '@/utils/mixins'
import { meetingRecords } from '@/utils/tableColumn'
import * as comm from "utils/common"
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export default {
  // mixins: [
  //   ListMixin
  // ],
  data () {
    return {
      tableData: [],
      tableController: {
        isActive: this.$_has('pdf-out') || this.$_has('m-edit') || this.$_has('m-del'),
        selection: false,
        index: true,
        width: 150,
        rowKey: ''
      },
      meetingRecords,
      textDialog: false,
      textContent: '',
      fileContent: [],
      time: '',
      selectlabel: '',
      treeData1: [],
      selectkey: '',
      treeExpandData: [],
      selectkeylist: [],
      type: '',
      selectOptions: [
        { value: '售前会议', type: '1' },
        { value: '项目会议', type: '2' }
      ],
      pagesize: 10,
      currentPage: 1,
      pageTotal: 10,
      // vloading: false,
      currentParams: {},
      pdfDialog:false,
      currentPdf:{},
      filterText: ''
    }
  },
  watch: {
    filterText(val) {
      this.$refs.selectlabel.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleEdit (item) {
      console.log("编辑：", item)
      // console.log("编辑："+index)
      this.$router.push({ path: "/meeting-manage/CreatingMeeting", query: { meetingId: item.id } })

    },
    outPdfBtn(e){
      this.pdfDialog = true
      this.currentPdf = e
      this.getBase64(this.currentPdf.fileInfoVO.path).then(base=>{
        this.currentPdf.fileInfoVO.path = base
      })
    },
    getBase64(img){
        function getBase64Image(img,width,height) {
            var canvas = document.createElement("canvas");
            canvas.width = width ? width : img.width;
            canvas.height = height ? height : img.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            var dataURL = canvas.toDataURL();
            return dataURL;
        }
        var image = new Image();
        image.setAttribute('crossOrigin', 'anonymous')//解决跨域
        image.crossOrigin = '';
        image.src = img;
        return new Promise((resolve,reject)=>{
            image.onload =function (){
                resolve(getBase64Image(image));//将base64传给done上传处理
            }
        });
    },
    exportToPdf1() {
      this.$message.success('pdf正在导出，请稍等...')
      let topimg = null
      html2canvas(document.querySelector("#export_top"), {
        dpi: 192, //导出pdf清晰度
        scale: 2,
        // useCORS: true,
        backgroundColor:'#ffffff',
        background: "#ffffff", //如果指定的div没有设置背景色会默认成黑色,这里是个坑
      }).then((canvas) => {
        //先渲染头部在渲染内容
        topimg = canvas.toDataURL("image/jpeg", 1.0);
        html2canvas(document.querySelector("#export_content"), {
          dpi: 192, //导出pdf清晰度
          scale: 2,
          backgroundColor:'#ffffff',
          background: "#ffffff", //如果指定的div没有设置背景色会默认成黑色,这里是个坑
        }).then((canvas) => {
          //未生成pdf的html页面高度
          var leftHeight = canvas.height;
          var a4Width = 190;
          var a4Height = 277; //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
          //一页pdf显示html页面生成的canvas高度;
          var a4HeightRef = Math.floor((canvas.width / a4Width) * a4Height);
          //pdf页面偏移
          var position = 0;
          var pageData = canvas.toDataURL("image/jpeg", 1.0);
          var pdf = new jsPDF("p", "mm", "a4"); //A4纸，纵向
          console.log('pdf',pdf,canvas);
          // pdf.setFontSize(20);
          // var logo = document.getElementById("pdftop");
          // var line = document.getElementById("pdfline");
          var bigTitle = document.getElementById("bigTitle");
          var topline = document.getElementById("topline");
          var toplogo = document.getElementById("toplogo");

          var index = 1,
            canvas1 = document.createElement("canvas"),
            height;
          pdf.setDisplayMode("fullwidth", "continuous", "FullScreen");

          var pdfName = "会议记录";
          function createImpl(canvas) {
            console.log(leftHeight, a4HeightRef);
            if (leftHeight > 0) {
              index++;
              var checkCount = 0;
              if (leftHeight > a4HeightRef) {
                var i = position + a4HeightRef;
                for (i = position + a4HeightRef; i >= position; i--) {
                  var isWrite = true;
                  for (var j = 0; j < canvas.width; j++) {
                    var c = canvas.getContext("2d").getImageData(j, i, 1, 1).data;

                    if (c[0] != 0xff || c[1] != 0xff || c[2] != 0xff) {
                      isWrite = false;
                      break;
                    }
                  }
                  if (isWrite) {
                    checkCount++;
                    if (checkCount >= 10) {
                      break;
                    }
                  } else {
                    checkCount = 0;
                  }
                }
                height =
                  Math.round(i - position) || Math.min(leftHeight, a4HeightRef);
                if (height <= 0) {
                  height = a4HeightRef;
                }
              } else {
                height = leftHeight;
              }

              canvas1.width = canvas.width;
              canvas1.height = height;

              var ctx = canvas1.getContext("2d");
              ctx.drawImage(
                canvas,
                0,
                position,
                canvas.width,
                height,
                0,
                0,
                canvas.width,
                height
              );

              var pageHeight = Math.round((a4Width / canvas.width) * height);
              if (position != 0) {
                pdf.addPage();
              }
              pdf.addImage(
                canvas1.toDataURL("image/jpeg", 1.0),
                "JPEG",
                10,
                20,
                a4Width,
                ((a4Width / canvas1.width) * height)-10
              );
              pdf.addImage(topimg, 'JPEG', 11, 3,190,16);
              // pdf.addImage(bigTitle, 'PNG', 11, 3);
              // pdf.addImage(topline, 'PNG', 11, 16);
              // pdf.addImage(toplogo, 'PNG', 16, 3);
              // pdf.addFont('NotoSansCJKtc-Regular.ttf', 'NotoSansCJKtc', 'normal');
              // pdf.setFont('NotoSansCJKtc');
              // pdf.setFontSize(16);
              // pdf.text(200,5, '广州天高软件科技有限公司');

              pdf.setFontSize(14);
              pdf.text(105,295, (index - 1) + '');
              // pdf.addImage(logo, 'PNG', 5, 3);
              // pdf.addImage(line, 'PNG', 7, 16);

              leftHeight -= height;
              position += height;
              if (leftHeight > 0) {
                setTimeout(createImpl, 500, canvas);
              } else {
                pdf.save(pdfName + ".pdf");
              }
            }
          }

          //当内容未超过pdf一页显示的范围，无需分页
          if (leftHeight < a4HeightRef) {
            pdf.addImage(
              pageData,
              "JPEG",
              10,
              20,
              a4Width,
              ((a4Width / canvas.width) * leftHeight)-10
            );
            pdf.addImage(topimg, 'JPEG', 11, 3,190,16);
            // pdf.addImage(bigTitle, 'PNG', 11, 3);
            // pdf.addImage(topline, 'PNG', 11, 16);
            // pdf.addImage(toplogo, 'PNG', 16, 3);
            // pdf.addFont('NotoSansCJKtc-Regular.ttf', 'NotoSansCJKtc', 'normal');
            // pdf.setFont('NotoSansCJKtc');
            // pdf.setFontSize(16);
            // pdf.text(200,5, '广州天高软件科技有限公司');

            pdf.setFontSize(14);
            pdf.text(105,295, "1");

            pdf.save(pdfName + ".pdf");
          } else {
            try {
              pdf.deletePage(0);
              setTimeout(createImpl, 500, canvas);
            } catch (err) {
              // console.log(err);
            }
          }
        });
      })


    },
    getTimes (e) {
      this.time = e || []
      this.ajaxLoadTable()
    },
    handleDelete (item) {
      console.log("删除：", item)
      // meetingDelete
      this.$confirm(`是否要删除会议${item.topic}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.meetingDelete(item.id).then(res => {
          if (res.code == 1000) {
            this.$message.success(res.msg)
            this.ajaxLoadTable()
          }
        })
      }).catch(() => {

      });
    },
    handleCurrentChange (pageNum) {
      console.log("分页页数改变：", pageNum, this.currentPage)
      //这里进行页面请求
      this.currentPage = pageNum
      this.ajaxLoadTable()
    },
    handleCreate () {
      //  创建会议
      router.push('/meeting-manage/CreatingMeeting')
    },
    getTime (s, e) {
      let long = (new Date(e).getTime() - new Date(s).getTime()) / 1000
      let day = Math.floor(long / (60 * 60 * 24))
      let hour = Math.floor((long - (day * 60 * 60 * 24)) / (60 * 60))
      let minues = Math.ceil((long - (day * 60 * 60 * 24) - (hour * 60 * 60)) / 60)
      // console.log(day,hour,minues)
      if (day) {
        return day + '天' + hour + '小时' + minues + '分钟'
      } else if (hour) {
        return hour + '小时' + minues + '分钟'
      } else {
        return minues + '分钟'
      }
    },
    getVersionName (e) {
      console.log(e);
      let projectVName = e.projectVersionVOList ? e.projectVersionVOList.map(item => item.version).join('/') : ''
      let projectName = e.projectVO ? e.projectVO.name : ''
      return e.type == 2 ? projectName + '(' + projectVName + ')' : '售前会议'
    },
    clearSendlabel () {
      this.selectkey = ''
      this.selectlabel = ''
      this.selectkeylist = []
      this.$refs.selectlabel.setCheckedKeys([])
      this.getSelectTree()
    },
    getChecked2 (checkedNodes, checkedKeys) {
      console.log(checkedKeys.checkedNodes)
      let keyList = []
      let labelList = []
      let checkNodes = checkedKeys.checkedNodes
      checkNodes.forEach(item => {
        if (item.mobile) {
          keyList.push(item.key)
          labelList.push(item.label)
        }
      })
      this.selectkeylist = keyList
      this.selectkey = keyList.join(';')
      this.selectlabel = labelList.join(';')
      // this.filterText = ''
    },
    getSelectTree () {
      api.getTreeAndPerson().then(res => {
        this.treeData1 = api.formatTreeAndPerson(res.data)
        this.treeExpandData.push(this.treeData1[0].key)
      })
    },
    manyExport () {
      this.currentParams.size = -1
      api.getMeetingList(this.currentParams).then(res => {
        if (res.code === 1000) {

          // this.tableData = res.data.records
          require.ensure([], () => {
            const {
              export_json_to_excel
            } = require('@/utils/excel-out/Export2Excel');
            const tHeader = ['会议类型', '会议主持', '会议主题', '所属项目', '会议时间', '会议时长', '会议地点', '会议参与人员'];
            const filterVal = ['type', 'hostList', 'topic', 'project', 'time', 'long', 'place', 'member'];
            const list = res.data.records.map(item => {
              return Object.assign(item, {
                type: item.type == 1 ? '售前会议' : (item.type == 2 ? '项目会议' : ''),
                hostList: item.hostList.join(';'),
                project: item.type == 2 ? (item.projectVO.name + '(' + item.projectVersionVOList.map(i => i.version).join(';') + ')') : '售前会议',
                time: item.startTime + '至' + item.endTime,
                long: this.getTime(item.startTime, item.endTime),
                member: item.attendeeList.map(v => v.name).join(';')
              })
            });
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, `会议信息列表`);
          })
        }
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    ajaxLoadTable () {
      if (!this.time) {
        this.time = []
      }
      let params = {
        current: this.currentPage,
        size: this.pagesize,
        startTime: this.time[0] || '',
        endTime: this.time[1] || '',
        type: this.type || 0,
        employeeIdList: this.selectkeylist.join(',')
      }
      this.currentParams = params
      // this.vloading = true
      api.getMeetingList(params).then(res => {
        this.tableData = res.data.records
        this.pageTotal = res.data.total
        // this.vloading = false
      })
    },
    checkDetail (e) {
      this.textDialog = true
      this.textContent = e.content
      this.fileContent = e.meetingAnnexVOList || []
    },
    donwload (e) {
      // window.open(e.path)
      comm.download(e.path, e.fileName)
    }
  },
  created () {
    this.getSelectTree()
    this.ajaxLoadTable()
  }

}
</script>
<style scoped>
.div-box >>> .el-loading-spinner .circular {
  width: 2px;
  height: 2px;
  animation: loading-rotate 2s linear infinite;
  display: none;
}
.div-box >>> .el-loading-spinner {
  background: url(../../assets/loading.gif) no-repeat;
  background-size: 200px 200px;
  background-color: rgba(255, 255, 255);
  /* width: 50%;
  height: 50%; */
  width: 200px;
  height: 200px;
  position: relative;
  top: 40%;
  left: 45%;
}
.textBox {
  padding: 10px;
  background: #f1f1f1;
}
.elInput >>> textarea {
  margin-top: 20px;
  outline: none;
  /* overflow: auto; */
  /* height: auto; */
  /* border: none; */
  /* border: 0 none; */
  border: 1px solid #fff !important;
  padding: 0;
  resize: none;
}
.pdf-box{
  padding:0.5rem 3rem;
}
.pdf-line{
  width: 100%;
  height: 1px;
  background: #000;
}
.pdf-img{
  /* height: 32px; */
}
.optionTree {
  width: 300px;
  height: auto;
}
.pdf-top{
  width: 100%;
  color: #000;
  /* display: none; */
}
.pt-1{
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0 30px;
}
.pt-1 >img{
  width: 60px;
  height: 35px;
}
.pt-1>div{
  font-size: 16px;
  font-weight: bold;
}
.pt-line1{
  /* width: calc(100% - 100px); */
  height: 2px;
  background: #000;
  margin-top: 7px;
  margin-bottom: 1px;
}
.pt-line2{
  /* width: calc(100% - 100px); */
  height: 4px;
  background: #000;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/meeting-manage/MeetingManagement.vue